export default __webpack_public_path__ + "static/media/img6.c351d164.PNG";